import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'
import { queryString } from '../../utils/queryString'

export const cardsSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    cards: build.query<any, { page?: number; limit?: number }>({
      query: ({ page = 1, limit = 10 }) => {
        const qs = queryString({ page, limit })
        return `${urlConfig.productsBaseUrl}/products/cards?${qs}`
      },
      providesTags: (result, error, page) =>
        result
          ? [
              ...result.data.map(({ _id }: { _id: string }) => ({
                type: 'Cards' as const,
                id: _id,
              })),
              { type: 'Cards', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Cards', id: 'PARTIAL-LIST' }],
    }),
    topHottestCards: build.query<any, void>({
      query: () => {
        const url = `${urlConfig.productsBaseUrl}/products/cards/top-hottest`
        console.log('Top hottest cards API URL:', url)
        return url
      },
      providesTags: [{ type: 'Cards', id: 'TOP-HOTTEST' }],
    }),
  }),
})

export const { useCardsQuery, useTopHottestCardsQuery } = cardsSlice
